"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.getPermission = getPermission;
exports.getPermissions = getPermissions;
exports.getRoles = getRoles;
exports.importRoutesPath = importRoutesPath;
exports.roleApi = void 0;
exports.updatePermission = updatePermission;
var _request = _interopRequireDefault(require("@/utils/request"));
var roleApi = {
  getRoles: getRoles
};
exports.roleApi = roleApi;
function getRoles() {
  return (0, _request.default)({
    url: "/v1/admin/role",
    method: "get"
  });
}
function importRoutesPath(data) {
  return (0, _request.default)({
    url: "/v1/admin/role/permissions/import",
    method: "post",
    data: data
  });
}
function addRole(data) {
  return (0, _request.default)({
    url: "/v1/admin/role",
    method: "post",
    data: data
  });
}
function getPermission(roleId) {
  return (0, _request.default)({
    url: "/v1/admin/role/".concat(roleId),
    method: "get"
  });
}
function getPermissions() {
  return (0, _request.default)({
    url: "/v1/admin/role/permissions",
    method: "get"
  });
}
function updatePermission(roleId, data) {
  return (0, _request.default)({
    url: "/v1/admin/role/".concat(roleId),
    method: "put",
    data: data
  });
}